import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const MinusFilled = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function MinusFilled({
  title = 'Minus',
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title === undefined ? <title id={titleId}>{'Minus'}</title> : title ? <title id={titleId}>{title}</title> : null}
        <path d="M23 10.5H1v3h22v-3Z" fill="currentColor" />
      </svg>;
}) as ForwardedIconComponent);
export default MinusFilled;